import { useMemo } from "react";
import css from "./main.module.css";
import lessonsImage from "../../img/lessonsImage.jpeg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const OneLessons = ({ lesson, getCategoryName, allLevels }) => {
  const { t, i18n } = useTranslation();

  const levelMapping = useMemo(
    () => ({
      "pre-A1": {
        fullName: "Pre-Beginner",
        order: 0,
        bgColor: "#c8e6c9",
        textColor: "#1b5e20",
        name: "pre-A1",
      },
      A1: {
        fullName: t("levelonea"),
        order: 1,
        bgColor: "#e8f5e9",
        textColor: "#2e7d32",
        name: "A1",
      },
      A2: {
        fullName: t("leveltwoa"),
        order: 2,
        bgColor: "#fff3e0",
        textColor: "#f57c00",
        name: "A2",
      },
      B1: {
        fullName: t("levevoneb"),
        order: 3,
        bgColor: "#e3f2fd",
        textColor: "#1565c0",
        name: "B1",
      },
      B2: {
        fullName: t("lebeltwob"),
        order: 4,
        bgColor: "#ede7f6",
        textColor: "#673ab7",
        name: "B2",
      },
      C1: {
        fullName: t("levelonec"),
        order: 5,
        bgColor: "#ffebee",
        textColor: "#d32f2f",
        name: "C1",
      },
      C2: {
        fullName: t("leveltwoc"),
        order: 6,
        bgColor: "#fce4ec",
        textColor: "#c2185b",
        name: "C2",
      },
    }),
    [i18n.language]
  );

  const levelData = useMemo(() => {
    if (!lesson?.video?.languageLevel) {
      console.log('No language level in lesson:', lesson);
      return null;
    }
    if (!Array.isArray(allLevels)) {
      console.log('allLevels is not an array:', allLevels);
      return null;
    }
    
    const level = allLevels.find(
      (lvl) => Number(lvl.id) === Number(lesson.video.languageLevel)
    );
    
    if (!level) {
      console.log('No matching level found:', {
        searchingFor: lesson.video.languageLevel,
        availableLevels: allLevels
      });
      return null;
    }
    
    if (!level.name) {
      console.log('Level found but no name:', level);
      return null;
    }
    
    const mappedLevel = levelMapping[level.name];
    if (!mappedLevel) {
      console.log('No mapping found for level name:', level.name);
      return null;
    }
    
    return mappedLevel;
  }, [lesson?.video?.languageLevel, allLevels, levelMapping]);

  return (
    <div className={css.wrapOneLessons}>
      <Link to={`/lesson/${lesson.id}`}>
        <img
          className={css.lessonsImage}
          src={lesson.video.thumbnail || lessonsImage}
          alt={lesson.video.name}
        />
      </Link>
      <Link to={`/lesson/${lesson.id}`} className={css.lessonsName}>
        {lesson.video.name}
      </Link>
      <p className={css.lessonsCategory}>
        {getCategoryName(lesson.video.category)}
      </p>
      <div className={css.wpapGreyL}>
        <p
          className={css.forWho}
          style={{ color: levelData?.textColor || "#000" }}
        >
          {levelData?.fullName || t("unknownLevel")}
        </p>
        <p
          className={css.countLevel}
          style={{
            backgroundColor: levelData?.textColor || "#ccc",
          }}
        >
          {levelData?.name || "?"}
        </p>
      </div>
    </div>
  );
};

export default OneLessons;
